import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useTask } from "context/client/task";

import ModalNew from "components/ModalNew";

const AcceptTaskModal = ({ title, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { updateTask } = useTask();

  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    try {
      setLoading(true);

      await updateTask({ status: 6 });
      onClose();
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <ModalNew
      title={t("Accept and close task")}
      status="success"
      loading={!!loading}
      labelSubmit="Yes, accept task"
      hasMobileScrollTop={false}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <p>
        {t("Are you sure you would like to accept and close the task")}{" "}
        <strong>{title}</strong>?<br />
        <br />
        {t(
          "This action cannot be reversed. Before closing the task make sure that everything you requested has been completed.",
        )}
      </p>
    </ModalNew>
  );
};

export default AcceptTaskModal;
